import React, { Component } from "react";
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import { connect } from "react-redux";
import {
  cartToQuantity,
  checkMOV,
  checkWalletBalance,
  setUsedComponents,
} from "../../../store/actions/b2b";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import { getProductInventory } from "../../../store/reducers/store";
import { withRouter } from "react-router-dom";

const getFirstValidQuantity = (min, inc) => {
  min = min || 1;
  const rem = min % inc;
  return rem === 0 ? min : min + (inc - rem);
};

const checkQuantity = (
  newQuantity,
  minimumOrderQuantity,
  maximumOrderQuantity,
  handleChangeQuantityState,
  setQuantity,
  increments,
  product,
  usedComponents,
  oldQuantity,
  setUsedComponents,
  setIsTyping,
  fromDetailsPage
) => {
  if (newQuantity === 0) {
    handleChangeQuantityState(0);
    return;
  }
  let maxInventory = Infinity;

  if (["stocked", "composite"].includes(product.type_of_product)) {
    maxInventory = parseInt(getProductInventory(product, usedComponents, true));

    if (!fromDetailsPage) {
      maxInventory += oldQuantity;
    }
  }

  let validQuantity = Math.max(
    Math.min(newQuantity, maximumOrderQuantity || Infinity),
    minimumOrderQuantity || -Infinity
  );

  validQuantity -= validQuantity % increments;

  validQuantity = Math.min(validQuantity, maxInventory);

  handleChangeQuantityState(validQuantity);
};

const checkQuantityDebounced = AwesomeDebouncePromise(checkQuantity, 500);

class index extends Component {
  state = { isTyping: false, quantityP: 1 };

  componentDidMount = () => {
    const { fromPage, product, minimumOrderQuantity } = this.props;
    if (fromPage == "details") {
      // let minQuantity = minimumOrderQuantity || 1
      // if (["stocked", "composite"].includes(product.type_of_product)) {
      //   let availableInventory = parseInt(
      //     getProductInventory(product, usedComponents, true)
      //   );
      //   minQuantity = Math.min(availableInventory,minQuantity)
      // }
      this.props.SetQuantity(minimumOrderQuantity || 1);
      this.setState({ quantityP: minimumOrderQuantity || 1 });
    }
  };
  setIsTyping = (newIsTyping) => {
    this.setState({ newIsTyping: newIsTyping });
  };
  increaseQuantity = () => {
    const {
      quantity,
      minimumOrderQuantity,
      maximumOrderQuantity,
      increments,
      cartToQuantity,
      checkMOV,
      checkWalletBalance,
      id,
      product,
      usedComponents,
      setUsedComponents,
    } = this.props;

    let quantity2 =
      this.props.fromPage == "details" ? this.state.quantityP : quantity;

    let newQuantity = quantity2 + increments;

    if (quantity2 === 0) {
      newQuantity = minimumOrderQuantity || increments;
      if (newQuantity % increments != 0) {
        newQuantity = increments;
      }
    }
    if (["stocked", "composite"].includes(product.type_of_product)) {
      let availableInventory = parseInt(
        getProductInventory(product, usedComponents, true)
      );
      if (this.props.fromPage != "details") {
        availableInventory += quantity;
      }

      newQuantity = Math.min(newQuantity, availableInventory);
    }

    if (maximumOrderQuantity && newQuantity > maximumOrderQuantity) {
      newQuantity = maximumOrderQuantity;
    }

    if (this.props.fromPage == "details") {
      this.props.SetQuantity(newQuantity);
      this.setState({ quantityP: newQuantity });
    } else {
      cartToQuantity(id, newQuantity);
      setUsedComponents({ product, quantityDelta: newQuantity - quantity });
    }

    checkMOV(this.props.cart, this.props.match.params.slug);
    checkWalletBalance(
      this.props.match.params.slug,
      this.props.phoneNumber,
      this.props.cart
    );
  };

  decreaseQuantity = () => {
    const {
      quantity,
      minimumOrderQuantity,
      increments,
      cartToQuantity,
      id,
      checkMOV,
      checkWalletBalance,

      product,
      usedComponents,
      setUsedComponents,
    } = this.props;
    let quantity2 =
      this.props.fromPage == "details" ? this.state.quantityP : quantity;
    if (quantity2 === 0) return;

    let newQuantity = quantity2 - increments;
    if (quantity2 <= minimumOrderQuantity || newQuantity <= 0) {
      newQuantity = 0;
    }
    if (this.props.fromPage == "details") {
      this.props.SetQuantity(newQuantity);
      this.setState({ quantityP: newQuantity });
    } else {
      cartToQuantity(id, newQuantity);
      setUsedComponents({ product, quantityDelta: newQuantity - quantity });
    }

    checkMOV(this.props.cart, this.props.match.params.slug);
    checkWalletBalance(
      this.props.match.params.slug,
      this.props.phoneNumber,
      this.props.cart
    );
  };

  handleChangeQuantityState = (value) => {
    if (this.props.fromPage == "details") {
      this.props.SetQuantity(value);
      this.setState({ quantityP: value });
    } else {
      const { quantity, product } = this.props;
      this.props.cartToQuantity(this.props.id, value);
      this.props.setUsedComponents({
        product,
        quantityDelta: value - quantity,
      });

      this.props.checkMOV(this.props.cart, this.props.match.params.slug);
      this.props.checkWalletBalance(
        this.props.match.params.slug,
        this.props.phoneNumber,
        this.props.cart
      );
    }
    this.setIsTyping(false);
  };
  handleQuantityChange = async (event) => {
    const newQuantity = +event.target.value;
    this.setIsTyping(true);

    await checkQuantityDebounced(
      newQuantity,
      this.props.minimumOrderQuantity,
      this.props.maximumOrderQuantity,
      this.handleChangeQuantityState,
      this.props.setQuantity,
      this.props.increments,
      this.props.product,
      this.props.usedComponents,
      this.props.quantity,
      this.props.setUsedComponents,
      this.setIsTyping,
      this.props.fromPage === "details"
    );
  };

  render() {
    const themeColor = this.props.themeColor;
    return (
      <div
        className={"mt-3 ".concat(
          this.props.language == "english"
            ? "float-right mr-4"
            : "float-left ml-4"
        )}
        style={{
          width: "120px",
          height: "30px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <RemoveCircleOutline
          className="float-left"
          onClick={() => this.decreaseQuantity()}
          style={{ color: themeColor, fontSize: 20, marginRight: 8 }}
        />

        <OutlinedInput
          id="outlined-basic"
          type={"number"}
          fullWidth={true}
          variant="outlined"
          onChange={this.handleQuantityChange}
          value={
            this.state.newIsTyping
              ? undefined
              : this.props.fromPage == "details"
              ? this.state.quantityP
              : this.props.quantity
          }
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value));
          }}
          color={"primary"}
          inputProps={{
            min: 0,
            style: { textAlign: "center", height: 5, padding: 13 },
            pattern: "[0-9]*",
          }}
        />
        <AddCircleOutline
          className="float-right"
          style={{ color: themeColor, fontSize: 20, marginLeft: 8 }}
          onClick={() => this.increaseQuantity()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    quantity: state.b2b.cartToQuantity[ownProps.id] || 0,
    usedComponents: state.b2b.usedComponents,
    // cartQuantities: state.b2b.cartToQuantity,
    cart: state.b2b.cartToQuantity,
    phoneNumber: state.b2b.phoneNumber,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    cartToQuantity: (id, value) => dispatch(cartToQuantity(id, value)),
    setUsedComponents: (payload) => dispatch(setUsedComponents(payload)),
    checkMOV: (cart, slug) => dispatch(checkMOV(cart, slug)),
    checkWalletBalance: (slug, phone, cart, method = null) =>
      dispatch(checkWalletBalance(slug, phone, cart, method)),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
